//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import date from '@/utils/date'
export default {
    data() {
        return {
            info: {},
            img: ''
        }
    },
    created() {
        if (!this.appointment) this.getOrderInfo()
        else{
            this.img = require(`@/assets/images/pc/appointment_success.png`)
        }    
    },
    computed: {
        appointment() {
            return this.$route.query.type === 'appointment'
        },
        title() {
            let title = '';
            if(this.info.orderStatus == 2 || this.info.orderStatus == 3 || this.info.orderStatus == 7) {
                title = '多謝選購我們的服務，服務合約副本將會於一小時內發送至您登記的電郵地址。'
                // title = '多謝選購我們的服務，您的SIM卡將於下個工作天以郵寄方式寄送，以及服務合約副本將會於一小時內發送至您登記的電郵地址。'
            }else title = '帶機上台'
            if (this.appointment) title = '感謝閣下登記中國移動月費服務計劃，我們的客戶主任將會盡快與您聯絡，處理閣下之申請'
            return title
        }
    },
    methods: {
        date,
        toView() {
            this.$router.push({
                name: 'confirm',
                query: {
                    id: this.info.id || this.info.businessOrderId,
                    packageType: this.info.businessType || this.info.purchaseType
                }
            })
        },
        backHome() {
            //回到中國移動首頁
            //https://1cm.hk.chinamobile.com/onlineshop/rateplan-only-list.html?lang=zh_hk
            let href =`${location.origin}` + '/umall/web/app/' + `${location.search}` + '#/mineBoss/orderQueryPlan?umallPlan=1&onlyNewTel=1&shrink=1'
            if(this.info && this.info.billType && this.info.billType!=1){
            	href=href+'&billType='+this.info.billType;
            }
            window.location.href = href
        },  
        getOrderInfo() {
            let { orderId, info } = this.$route.query
            if(info) {
                this.info = JSON.parse(info)
                this.img = require(`@/assets/images/pc/orderStatus_big_${this.info.orderStatus}.png`)
                return
            }
            return this.$http('order/getOrderInfo', {mainOrderId: orderId,orgId:this.$client.orgid,shopId:this.$client.shopid,userId:this.$client.userid,}).then(res=>{
                if(res.returnCode == 1000) {
                    this.info = res.dataInfo
                    let _img;
                    if(this.$route.params.status == 'info') _img = this.info.orderStatus
                    else _img = (this.$route.params.status == 'success' ? '4' : '1')
                    this.img = require(`@/assets/images/pc/orderStatus_big_${_img}.png`)
                }
            })
        }
    }
}
